import amatic from '../assets/images/providers/amatic.png';
import aristocrat from '../assets/images/providers/aristocrat.png';
import betsoft from '../assets/images/providers/betsoft.png';
import egt from '../assets/images/providers/egt.png';
import evolution from '../assets/images/providers/evolution.png';
import evoplay from '../assets/images/providers/evoplay.png';
import ezugi from '../assets/images/providers/ezugi.png';
import gameart from '../assets/images/providers/gameart.png';
import goldenrace from '../assets/images/providers/goldenrace.png';
import habanero from '../assets/images/providers/habanero.png';
import ka from '../assets/images/providers/ka.png';
import netent from '../assets/images/providers/netent.png';
import novomatic_deluxe from '../assets/images/providers/novomatic_deluxe.png';
import novomatic from '../assets/images/providers/novomatic.png';
import palyson from '../assets/images/providers/palyson.png';
import platipus from '../assets/images/providers/platipus.png';
import pragmaticplay from '../assets/images/providers/pragmaticplay.png';
import spinmatic from '../assets/images/providers/spinmatic.png';
import spinomenal from '../assets/images/providers/spinomenal.png';
import wazdan from '../assets/images/providers/wazdan.png';
import weare from '../assets/images/providers/weare.png';
import yggdrasil from '../assets/images/providers/yggdrasil.png';
import pro from '../assets/images/providers/pro.png';
import vivo from '../assets/images/providers/vivo.png';
import vibra from '../assets/images/providers/vibra.png';
import playngo from '../assets/images/providers/playngo.png';
import kagaming from '../assets/images/providers/kagaming.png';
import iconix from '../assets/images/providers/iconix.png';
import netgame from '../assets/images/providers/netgame.png';
import playson from '../assets/images/providers/playson.png';
import endorphina from '../assets/images/providers/endorphina.png';
import igt from '../assets/images/providers/igt.png';
import microgaming from '../assets/images/providers/microgaming.png';
import patagonia from '../assets/images/providers/patagonia.png';
import ortiz from '../assets/images/providers/ortiz.png';
import wearecasino from '../assets/images/providers/wearecasino.png';
import worldmatch from '../assets/images/providers/worldmatch.png';
import medialive from '../assets/images/providers/medialive.png';
import hollywoodtv from '../assets/images/providers/hollywoodtv.png';
import xpg from '../assets/images/providers/xpg.png';

export default {
  amatic, aristocrat, 
  betsoft, egt,
  evolution, evoplay,
  ezugi, gameart,
  goldenrace, habanero,
  ka,netent, novomatic,
  novomatic_deluxe, palyson,
  platipus,pragmaticplay,
  spinmatic,spinomenal,
  wazdan, weare,
  yggdrasil, pro, vivo, vibra,
  playngo, kagaming, iconix, 
  netgame, playson, endorphina,
  igt, microgaming, ortiz, patagonia,
  wearecasino, worldmatch, medialive,
  hollywoodtv, xpg
};
